import { gql } from "@apollo/client"
import { capitalize } from "@tmu/utils/string"

export const OFFER_DETAIL_QUERY = ({ locale }) => {
  const localeCapital = capitalize(locale)

  return gql`
    query OfferDetail($slug: String!) {
      offer(slug: $slug) {
        id
        slug
        name
        shortDescription
        shortDescription${localeCapital}
        description
        description${localeCapital}
        image
        maxPacDiscount
        virtualEventLink
        eventMapLink
        location
        visibilityStatus
        isAvailable
        startDate
        eventStartsAt
        endDate
        maxPrice
        minPrice
        price
        vatAmount
        vatPercentage
        pacDiscountAmount
        isNeedTicketBuyerInfo
        total
        isUnlisted
        isFeatured
        stripePublicKey
        isDefaultOffer
        addressLine1
        isEventOffer
        city
        country
        postCode
        location
        location
        phoneNumber
        showAddressAndPhone
        isReservationRequired
        startDateVisibility
        isVoucher
        isInvoiceMandatory
        activePromotion {
          id
        }
        allowUsersToSelectADifferentCampaign
          favoriteCharity {
            id
            name
            nameEn
            nameIt
            nameEs
            pacMultiplier
            partner {
              logo
              logoEn
              logoEs
              logoIt
            }
          }
        promotions {
          id
        }
        store {
          id
          name
          displayName
          logo
          slug
          shortDescription
          shortDescription${localeCapital}
          description
          description${localeCapital}
          phoneNumber
          defaultOffer {
            phoneNumber
            addressLine1
            city
            country
            postCode
            location
          }
          image
          images {
            edges {
              node {
                id
              }
            }
          }
          allowUsersToSelectADifferentCampaign
          favoriteCharity {
            id
            name
            nameEn
            nameIt
            nameEs
            pacMultiplier
            partner {
              logo
              logoEn
              logoEs
              logoIt
            }
          }
        }
        productVariation {
          edges {
            node {
              id
              name
              name${localeCapital}
              description
              description${localeCapital}
              price
              pacDiscount
              maxTickets
              isUnlimitedTickets
              isSoldOut
              stockLeft
              allowCustomAmount
            }
          }
        }
      }
    }
  `
}

export const TERMINAL_OFFER_DETAIL_QUERY = gql`
  query OfferDetailTerminal($slug: String!) {
    offer(slug: $slug) {
      id
      slug
      name
      description
      descriptionEn
      descriptionIt
      descriptionEs
      image
      store {
        id
        name
        displayName
        logo
        slug
        image
      }
      productVariation {
        edges {
          node {
            id
            name
            nameEn
            nameIt
            nameEs
            description
            descriptionEn
            descriptionIt
            descriptionEs
            price
            pacDiscount
            maxTickets
            isUnlimitedTickets
            isSoldOut
            stockLeft
            allowCustomAmount
          }
        }
      }
    }
  }
`

export const TERMINAL_MERCHANT_OFFER_LISTING_QUERY = gql`
  query OfferListing1(
    $offset: Int
    $first: Int
    $after: String
    $search: String
    $categories: [ID]
    $orderBy: String
    $availableCountries: String
    $availableCities: [ID]
    $badge: [String]
    $offerOrigin: [String]
    $offerType_In: [MerchantsOfferOfferTypeChoices]
    $store: [ID]
    $maxPacDiscount_Lte: Decimal
    $maxPacDiscount_Gte: Decimal
    $maxPrice_Lte: Decimal
    $maxPrice_Gte: Decimal
    $isDefaultOffer: Boolean
  ) {
    allOffers(
      offset: $offset
      first: $first
      after: $after
      search: $search
      categories: $categories
      availableCountries: $availableCountries
      availableCities: $availableCities
      orderBy: $orderBy
      badge: $badge
      offerOrigin: $offerOrigin
      offerType_In: $offerType_In
      store: $store
      maxPacDiscount_Lte: $maxPacDiscount_Lte
      maxPacDiscount_Gte: $maxPacDiscount_Gte
      isDefaultOffer: $isDefaultOffer
      maxPrice_Lte: $maxPrice_Lte
      maxPrice_Gte: $maxPrice_Gte
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
      pageCount
      edges {
        node {
          id
          slug
          name
          image
          descriptionEn
          descriptionIt
          descriptionEs
          maxPacDiscount
          isDefaultOffer
          offerType
          isEventOffer
          store {
            id
            logo
            displayName
            name
            slug
          }
        }
      }
    }
  }
`
